import React, { useEffect, useRef } from "react";

const PopoutShapeMenu = ({ visible, anchor, selectedShape, onSelectShape, onClose }) => {
  const menuRef = useRef(null);

  const shapes = [
    { id: "square", label: "Square", icon: "▢" },
    { id: "circle", label: "Circle", icon: "●" },
    { id: "line", label: "Line", icon: "—" },
  ];

  // Close on outside click
  useEffect(() => {
    if (!visible) return;

    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [visible, onClose]);

  if (!visible) return null;

  const styles = {
    position: "fixed",
    top: anchor.y,
    left: anchor.x,
    backgroundColor: "#222",
    border: "1px solid #444",
    borderRadius: "4px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
    zIndex: 1000,
    padding: 8,
    display: "flex",
    flexDirection: "column",
    gap: 8,
  };

  return (
    <div
      ref={menuRef}
      style={styles}
      role="dialog"
      aria-label="Shape tools"
    >
      {shapes.map((shape) => (
        <button
          key={shape.id}
          type="button"
          className={`toolbar-btn ${selectedShape === shape.id ? "active" : ""}`}
          aria-label={shape.label}
          aria-pressed={selectedShape === shape.id}
          title={shape.label}
          style={{
            display: "flex",
            flex: "0 0 auto",
            width: 48,
            height: 48,
            padding: 8,
          }}
          onClick={() => {
            onSelectShape(shape.id);
            onClose();
          }}
        >
          <span aria-hidden="true" style={{ fontSize: 18, fontWeight: "bold" }}>
            {shape.icon}
          </span>
        </button>
      ))}
    </div>
  );
};

export default PopoutShapeMenu;
